/**
 * Created by moort on 1/9/19.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Center from 'react-center';
import Avatar from '@material-ui/core/Avatar';
import { FaLinkedin, FaTwitterSquare, FaEnvelopeSquare } from 'react-icons/fa';
import Collapse from '@material-ui/core/Collapse';
import avatars from './avatars'


const styles = theme => ({
    contactJobTitle:{
        marginLeft: 15,
        marginBottom: 5,
        fontSize: 14
    },
    mobileListItem:{
        textAlign: 'center'
    },
    showMore:{
        textDecorationLine: 'underline',
        textAlign: 'left',
        color: theme.palette.primary.light,
        cursor: 'pointer'
    },
    speakerName:{
        fontFamily: 'Raleway',
        fontWeight: 'bold',
        color: theme.palette.primary.dark,
        fontSize: 26
    },
    speakerBioFull:{
        fontFamily: 'Raleway',
        fontWeight: 'bold',
        fontSize: 16,
        marginTop: 10
    },
    speakerBio:{
        fontFamily: 'Raleway',
        fontWeight: 'bold',
        fontSize: 16,
        marginTop: 10,

        display: 'block',
        display:'-webkit-box',
        maxHeight: '5.5em',
        margin: '0 auto',
        lineHeight: 1.4,
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    icon: {
        marginRight: 4,
        fontSize: 24
    },
    contactIcons:{
        width: '100%',
        textAlign: 'center'
    },
    speakerListItem:{
        fontFamily: 'Raleway',
        fontWeight: 'bold',
        fontSize: 14,
    },
    speakerListItemTitle:{
        fontFamily: 'Raleway',
        fontWeight: 'bold',
        fontSize: 20
    },
    bigAvatar: {
        cursor: 'pointer',
        width: 80,
        height: 80,
    }
});

class MobileSpeakerCard extends React.Component {

    constructor(props) {
        super(props);
        const {classes} = props;

        this.state = {
            classes: classes,
            speakerName: props.speakerName,
            speakerTitle: props.speakerTitle,
            speakerAvatar: props.speakerAvatar,
            speakerBio: props.speakerBio,
            speakerLinkedIn: props.speakerLinkedIn,
            speakerTwitter: props.speakerTwitter,
            speakerEmail: props.speakerEmail,
            avatar:  avatars[props.speakerAvatar],
            noWrap: props.hideShowMore  ? false : true,
            showMoreText: "Read more"
        };

    }

    componentDidMount(){
    }

    showMoreLess(e){
        var showMoreText = "Hide bio";
        if(!this.state.noWrap){
            showMoreText = "Read more";
        }
        this.setState({noWrap:!this.state.noWrap,showMoreText:showMoreText})
    }

    showSpeakerDetails(){
        if(this.props.showSpeakerPopUp && this.state.speakerBio){
            this.props.showSpeakerPopUp(this.state);
        }
    }

    render() {


        return (
            <div>
                <Center>
                    <Avatar onClick={this.showSpeakerDetails.bind(this)} alt={this.state.speakerName} className={this.state.classes.bigAvatar} src={this.state.avatar} />
                </Center>
                <Center>
                    <div className={this.state.classes.speakerName} color="textPrimary">
                        {this.state.speakerName}
                    </div>
                </Center>
                <Center>
                    {this.state.speakerTitle?<Typography component="span" className={this.state.classes.speakerListItem} color="textPrimary">
                        <div>
                            {this.state.speakerTitle}
                        </div>
                    </Typography>:null}
                </Center>
                <Center>
                    {this.state.speakerBio && this.state.noWrap ?
                        <Typography  component="span"
                                     className={this.state.classes.speakerBio} color="textPrimary">
                            {this.state.speakerBio}
                        </Typography>
                        :null}
                    {this.state.speakerBio && !this.state.noWrap ?
                        <Typography  component="span"
                                     className={this.state.classes.speakerBioFull} color="textPrimary">
                            {this.state.speakerBio}
                        </Typography>
                        :null}
                </Center>
                <Center>
                    {this.state.speakerBio && !this.props.hideShowMore?<Typography component="span" className={this.state.classes.speakerListItem}
                                                                                   color="textPrimary">
                        <div className={this.state.classes.showMore} onClick={this.showSpeakerDetails.bind(this)}>
                            {this.state.showMoreText}
                        </div>
                        <br/>
                    </Typography>:null}
                </Center>
                <Center>
                    <div className={this.state.classes.contactIcons}>
                        {this.state.speakerEmail?<a href={"mailto:"+encodeURI(this.state.speakerEmail)}><FaEnvelopeSquare className={this.state.classes.icon}/></a>:null}
                        {this.state.speakerLinkedIn?<a href={this.state.speakerLinkedIn} target="_blank"><FaLinkedin className={this.state.classes.icon}/></a>:null}
                        {this.state.speakerTwitter?<a href={this.state.speakerTwitter} target="_blank"><FaTwitterSquare className={this.state.classes.icon}/></a>:null}
                    </div>
                </Center>
            </div>
        );
    }
};

MobileSpeakerCard.propTypes = {
    classes: PropTypes.object.isRequired,
    hideShowMore:PropTypes.object.isRequired,
    showSpeakerPopUp: PropTypes.object.isRequired,
    speakerName: PropTypes.string.isRequired,
    speakerTitle: PropTypes.string.isRequired,
    speakerAvatar: PropTypes.object.isRequired,
    speakerBio: PropTypes.object,
    speakerLinkedIn: PropTypes.string,
    speakerTwitter: PropTypes.string,
    speakerEmail: PropTypes.string
}

export default withStyles(styles)(MobileSpeakerCard);